import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CommentsGrid, AdminAppIdHeader } from 'areas/shared/components';
import { SetupTab } from 'areas/shared/pages/setup';
import { ActionButton } from 'fw/components';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import { QueueType } from 'areas/shared/consts';
import BankInfoItem from './BankInfoItem';

class BankInfo extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            bankAccountsList: [],
            reviewComment: '',
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    updatePostData = (form, dirty) => {
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    validateReviewStatus = (form) => {
        let canComplete=
            (
                this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
            ) ||
            this.state.form.bankAccountsList.every((item) => { 
                return (item.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument })
                    && (item.otherDocuments == null
                        || item.otherDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })));
            });

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getBankingInfo'),
            save: API.Admin.url('/certification/saveBankingInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            reviewStatus: this.state.form.reviewStatus,
            reviewUploads: this.state.form.reviewUploads,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            bankAccountsList: this.state.form.bankAccountsList,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    ready = () => {
        // If currentStep is disabled (fastTrack), then go to tab "Cert."
        const currentStepIndex = this.props.setupProps.tabs.findIndex(tab => tab.key === "bankInfo");
        if (this.props.setupProps.tabs[currentStepIndex].disabled)
            this.props.handleTabSelect("businessCertification");

        // Add a bank account to be filled
        if (this.state.form.bankAccountsList.length === 0)
            this.addBankAccount();

        this.focusControl && this.focusControl.focus();
    }

    addBankAccount = () => {
        let item = {
            entityId: -Math.abs(Date.now() | 0),
            phones: [
                {
                    phoneTypeCode: "MOBILE",
                    number: "",
                    extension: "",
                    phoneId: -Math.abs(Date.now() | 0)
                }
            ],
            reviewUploads: [
                {
                    upload: {
                        uploadKey: "BankResolution"
                    }
                },
                {
                    upload: {
                        uploadKey: "BankingSignatureCard"
                    }
                },
                {
                    upload: {
                        uploadKey: "CancelledChecks"
                    }
                }
            ],
            otherDocuments: []
        }

        let form = this.state.form
        form.bankAccountsList = form.bankAccountsList.concat(item)

        this.updatePostData(form)
    }

    removeBankAccount = (index) => {
        let form = this.state.form

        form.bankAccountsList.splice(index, 1)

        this.updatePostData(form, true)
    }

    onUpdateBankAccountsList = (index, item) => {
        let form = this.state.form

        form.bankAccountsList[index] = item
        this.updatePostData(form, true)
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "BankingInfoReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;


        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'BNK'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Banking Information – <small>Please submit all required Banking Documents</small>
                                    {this.renderAdminStepToolbar()}
                                    {this.state.form.allowPrinting && <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>}
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <BankInfoItem
                            bankAccountsList={this.state.form.bankAccountsList}
                            onUpdateBankAccountsList={this.onUpdateBankAccountsList}
                            queueTypeCode={this.state.form.certificationQueueTypeCode}
                            addBankAccount={this.addBankAccount}
                            removeBankAccount={this.removeBankAccount}
                            ref={'_bankAccountsList'}
                            tooltips={this.state.tooltips}
                            isRenewal={this.state.form.isRenewal}
                        />
                    </Col>
                </Row>
                {
                    this.state.form.showReview ?
                        <React.Fragment>
                            <Row>
                                <CommentsGrid
                                    ref={(c) => { this._commentsGrid = c }}
                                    comments={this.state.form.comments}
                                    documents={this.state.form.reviewDocuments}
                                    certificationKey={this.props.selectedId}
                                    reviewTypeCode={"BNK"}
                                    queueTypeCode={this.state.form.certificationQueueTypeCode}
                                    enableExport={true}
                                    entityId={this.state.form.savedEntityId}
                                    readonly={!this.state.privileges.edit || !this.state.enabled}
                                    onSave={this.handleCommentsGrid} 
                                    onCommentChange={this.handleCommentChange} />
                            </Row>
                            {this.state.form.showComplete ?
                                <Row>
                                    <ReviewPanel stepName="Bank Information"
                                        canComplete={(
                                            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                        ) ||
                                        this.state.form.bankAccountsList.every((item) => { 
                                            return (item.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument })
                                                && (item.otherDocuments == null
                                                    || item.otherDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })));
                                        })}
                                        onChange={this.handleReviewStatus}
                                        reviewStatus={this.state.form.reviewStatus} />
                                </Row>
                                : null}
                        </React.Fragment> 
                        : null}
            </React.Fragment >
        )
    }
}

export default BankInfo; 



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/bankInfo/BankInfo.js